<template>
    <BlockLabelNormal v-if="!timerOnZoom" :label="label" :timeCounter="timeCounter" />
    <BlockLabelZoom v-else :label="label" :timeCounter="timeCounter" />
</template>
<script>
import BlockLabelNormal from './BlockLabelNormal';
import BlockLabelZoom from './BlockLabelZoom';
export default {
    name: 'BlockLabel',
    components:{
        BlockLabelNormal,
        BlockLabelZoom
    },
    props:{
        timeCounter:{
            type: Number,
            default: 0
        },
        label:{
            type: String,
            default: null
        },
        timerOnZoom:{
            type: Boolean,
            default: true
        }
    }
}
</script>